var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-svg",
    viewBox: "0 0 54.127 61.859",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-shopping-bag",
    "data-name": "Icon awesome-shopping-bag",
    d: "M42.528,19.331V15.465a15.465,15.465,0,0,0-30.93,0v3.866H0V52.194A9.666,9.666,0,0,0,9.666,61.86h34.8a9.666,9.666,0,0,0,9.666-9.666V19.331Zm-23.2-3.866a7.732,7.732,0,0,1,15.465,0v3.866H19.331Zm19.331,14.5a2.9,2.9,0,1,1,2.9-2.9A2.9,2.9,0,0,1,38.662,29.963Zm-23.2,0a2.9,2.9,0,1,1,2.9-2.9A2.9,2.9,0,0,1,15.465,29.963Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.d79a229ac9507ee8613f4902a68f3183.svg";
export { ForwardRef as ReactComponent };